import React, { Component } from 'react';

import { SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN } from 'client/constants/screenIds';

import { SR_API_ACTION_UTILITY_ACTIVATION_TRACK_INTERNET_FLOW } from 'api/utilityActionTypes';
import { ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_SEARCH_PROVIDER_NAME } from 'client/analytics/eventList';

import withTransitionHook from 'client/helpers/withTransitionHook';
import withScreenId from 'client/helpers/withScreenId';
import withScrollToTop from 'client/helpers/withScrollToTop';
import withLocationQuery from 'client/helpers/withLocationQuery';

import branch from 'client/core/branch';
import requestUtilityApi from 'client/actions/requestUtilityApi';
import UtilityPartnerActions from 'client/actions/UtilityPartner';
import UtilityActivationActions from 'client/actions/UtilityActivation';

import SrUtilitySetupPage from 'client/components/SrUtilitySetup/SrUtilitySetupPage';
import SrUtilitySetupProviderPlan from 'client/components/SrUtilitySetup/SrUtilitySetupProviderPlan';

@withTransitionHook
@withLocationQuery
@withScreenId(SCREEN_ID_UTILITY_SETUP_PROVIDER_PLAN)
@withScrollToTop
@branch(({ match }) => ({
  utilityActivation: ['utilityActivations', 'byShortId', match.params.utilityActivationShortId],
  utilityPartner: ['utilityPartners', 'bySlug', match.params.partnerSlug],
}))
@branch(({ utilityActivation }) => {
  if (utilityActivation) {
    return {
      internetProviders: [
        'utilityProviders',
        'internetPlansByPartnerAddressId',
        utilityActivation.utilityPartnerAddressId,
      ],
    };
  }
  return {};
})
class UtilitySetupProviderPlanPage extends Component {
  static getPageMetadata = () => ({
    pageTitle: 'Utility Setup | Plan',
  });

  static fetchData(match, inject) {
    return Promise.all([
      UtilityPartnerActions.getBySlug(inject, {
        slug: match.params.partnerSlug,
      }),
      UtilityActivationActions.getByShortId(inject, {
        utilityActivationShortId: match.params.utilityActivationShortId,
      }),
    ]).then(([, utilityActivation]) => {
      if (utilityActivation) {
        return UtilityActivationActions.getInternetPlans(inject, {
          utilityPartnerAddressId: utilityActivation.utilityPartnerAddressId,
        });
      }
      return Promise.resolve();
    });
  }

  constructor(props) {
    super(props);

    this.state = {
      showTransferredAccountModal: false,
    };
  }

  _refreshUtilityActivation = () => {
    const { dispatch, utilityActivation } = this.props;
    return dispatch(UtilityActivationActions.getByShortId, {
      utilityActivationShortId: utilityActivation.shortId,
      forceRefresh: true,
    });
  };

  render() {
    const {
      dispatch,
      utilityPartner,
      utilityActivation,
      match,
      history,
      locationQuery,
      internetProviders,
    } = this.props;

    const { showTransferredAccountModal } = this.state;

    const utilityTypeLabel = match.params.utilityTypeLabel;

    if (!utilityPartner || !utilityActivation || !internetProviders) {
      return null;
    }

    const utilityActivationItem = utilityActivation.items.find(
      (item) => item.type.label.toLowerCase() === utilityTypeLabel,
    );

    const onStartTransferInternetFlow = () => {
      const { dispatch } = this.props;

      return dispatch(requestUtilityApi, {
        action: SR_API_ACTION_UTILITY_ACTIVATION_TRACK_INTERNET_FLOW,
        payload: {
          utilityActivationId: utilityActivation.id,
          internetFlowEventName: ANALYTICS_EVENT_UTILITY_SETUP_INTERNET_FLOW_SEARCH_PROVIDER_NAME,
        },
      })
        .then(() => {
          this.setState({
            showTransferredAccountModal: true,
          });
        })
        .catch(() => {
          this.setState({
            showTransferredAccountModal: true,
          });
        });
    };

    const onCloseTransferFlow = () => {
      this.setState({
        showTransferredAccountModal: false,
      });
    };

    return (
      <SrUtilitySetupPage
        addressDisplay={utilityActivation.address?.display}
        utilityPartner={utilityPartner}
        utilityActivationId={utilityActivation.id}
        logoUrl={utilityPartner.logoUrl}
        backButtonText="Back"
        backButtonUrl={`/utility-setup/${utilityPartner.slug}/${utilityActivation.shortId}`}
      >
        <SrUtilitySetupProviderPlan
          dispatch={dispatch}
          history={history}
          locationQuery={locationQuery}
          utilityPartner={utilityPartner}
          utilityActivation={utilityActivation}
          utilityActivationItem={utilityActivationItem}
          utilityProviders={internetProviders || utilityActivationItem.availableProviders}
          transferFlowIsActive={showTransferredAccountModal}
          onStartTransferInternetFlow={onStartTransferInternetFlow}
          onCloseTransferFlow={onCloseTransferFlow}
          onRefreshUtilityActivation={this._refreshUtilityActivation}
        />
      </SrUtilitySetupPage>
    );
  }
}

UtilitySetupProviderPlanPage.displayName = 'UtilitySetupProviderPlanPage';

export default UtilitySetupProviderPlanPage;
